import { motion } from 'motion/react'

type SignupStepProgressProps = {
  signupStep: number
  steps: Array<{ number: number; label: string }>
}

export const SignupStepProgress = ({ signupStep, steps }: SignupStepProgressProps) => (
  <div className="space-y-0.5">
    <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-(--color-text-muted)">
        Step {signupStep} di {steps.length}
    </p>
    <motion.p
      key={signupStep}
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -4 }}
      transition={{ duration: 0.2 }}
      className="text-sm font-semibold text-(--color-text-primary)"
    >
      {steps[Math.max(0, Math.min(steps.length - 1, signupStep - 1))]?.label ?? ''}
    </motion.p>
  </div>
)
